// src/CartContext.js
import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);
  const [orderType, setOrderType] = useState('Dine-In');

  const addToCart = (item, opts = {}) => {
    setCartItems(ci => {
      // if already in cart (matching name + gf flag), do nothing
      if (
        ci.find(
          i =>
            i.name === item.name &&
            (!!i.glutenFreeOption === !!opts.glutenFreeOption)
        )
      )
        return ci;
      return [
        ...ci,
        {
          ...item,
          quantity: 1,
          note: '',
          glutenFreeOption: !!opts.glutenFreeOption
        }
      ];
    });
  };

  const updateQuantity = (name, qty, gfFlag) => {
    setCartItems(ci =>
      ci
        .map(i =>
          i.name === name && i.glutenFreeOption === gfFlag
            ? { ...i, quantity: qty }
            : i
        )
        .filter(i => i.quantity > 0)
    );
  };

  const removeFromCart = (name, gfFlag) => {
    setCartItems(ci =>
      ci.filter(i => !(i.name === name && i.glutenFreeOption === gfFlag))
    );
  };

  const getItemQuantity = (name, gfFlag) => {
    const it = cartItems.find(
      i => i.name === name && i.glutenFreeOption === gfFlag
    );
    return it ? it.quantity : 0;
  };

  const updateNote = (name, note, gfFlag) => {
    setCartItems(ci =>
      ci.map(i =>
        i.name === name && i.glutenFreeOption === gfFlag
          ? { ...i, note }
          : i
      )
    );
  };

  const deleteNote = (name, gfFlag) => updateNote(name, '', gfFlag);

  const clearCart = () => setCartItems([]);

  return (
    <CartContext.Provider
      value={{
        cartItems,
        orderType,
        setOrderType,
        addToCart,
        updateQuantity,
        removeFromCart,
        getItemQuantity,
        updateNote,
        deleteNote,
        clearCart
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
